import {
  ClickAwayListener,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Popper,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useRef, useState } from 'react';
import { usePublicConfig } from '@pv/common/providers';
import { useUserAuth } from '../../../../../providers/auth';
import { apiHost } from '@pv/common/api';
import { UserAvatar } from '../../../../Avatar';
import { usePostHog } from 'posthog-js/react';

const API_HOST = apiHost(process.env.REACT_APP_PV_ENV);

const AccountButton = () => {
  const { publicConfig } = usePublicConfig();
  const accountRef = useRef(null);
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const { user } = useUserAuth();
  const posthog = usePostHog();

  const openAccountPopover = () => {
    setOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const onAccountPopoverClose = () => {
    setOpen(false);
    document.body.style.overflow = '';
  };

  return (
    <>
      <IconButton
        aria-label="Account Menu"
        title="Account Menu"
        className="account-menu-button"
        onClick={openAccountPopover}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          marginLeft: theme.spacing(1),
        }}
        ref={accountRef}
      >
        <UserAvatar userId={user.id} />
      </IconButton>
      <Popper
        placement="bottom-end"
        anchorEl={accountRef.current}
        sx={{ zIndex: theme.zIndex.appBar + 100 }}
        open={open}
        style={{ position: 'fixed' }}
      >
        <ClickAwayListener onClickAway={onAccountPopoverClose}>
          <Paper
            className="account-menu"
            sx={{ marginTop: theme.spacing(1) }}
            elevation={3}
          >
            <List>
              <ListItem disablePadding>
                <ListItemButton
                  component={Link}
                  href="/settings/profile"
                  sx={{ textDecoration: 'none' }}
                >
                  <ListItemText>My Profile</ListItemText>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => {
                    posthog.reset();
                    window.location.href = `${API_HOST}${publicConfig.paths.destroyUserSession}`;
                  }}
                >
                  <ListItemText>Logout</ListItemText>
                </ListItemButton>
              </ListItem>
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default AccountButton;
